<div>
  <article class="article">
    <!--<p class="title" [innerHTML]="'home.start.eveenoTitle' | translate"></p>-->
    <div *ngIf="text" style="display: flex; margin-left: 60px">
      <p class="description" [innerHTML]="text">
    </div>
  </article>
</div>

<div class="d-flex">
  <ng-container *ngIf="image">
    <a *ngIf="url; else noUrl" [href]="url" target="_blank">
      <img [src]="image" style="width: 100%; cursor: pointer;" />
    </a>
    <ng-template #noUrl>
      <img [src]="image" style="width: 100%; cursor: default;" />
    </ng-template>
  </ng-container>
</div>
